// eslint-disable-next-line max-classes-per-file
import {ProcessFlowBaseNode} from './process-flow-base-node';
import {ProcessFlowNodeOutlet} from './process-flow-node-outlets';

export class OrJoinNode extends ProcessFlowBaseNode {
  constructor(v: Partial<OrJoinNode>) {
    super(v);
    this.type = 'ProcessFlow::OrJoinNode';

    this.supportedOutlets = [
      ProcessFlowNodeOutlet.COMPLETED_OUTLET
    ];
  }
}
